import { BlockTypeEnum } from '../../enum/block/block-type.enum';

const STICKY_BLOCKS = [ BlockTypeEnum.LargeHeader, BlockTypeEnum.Header ];

export const isStickyBlockType = (blockType: BlockTypeEnum) => STICKY_BLOCKS.indexOf(blockType) !== -1;
